export default __webpack_public_path__ + "static/media/drinks.2a10ff58.png";